module.exports = "<input type=\"text\" ng-model=\"value\" class=\"col-xs-12\">\n";